/**
 * @license
 * Copyright (c) 2018-present, Loomble Inc <opensource@loomble.com>
 * Copyright (c) 2018-preset, Jay Rylan <jay@jayrylan.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Included documentation is from "[HTTP request methods][MDN]" by
 * [Mozilla Contributors][Contributors] and licensed under
 * [CC-BY-SA 4.0][CC-BY-SA].
 *
 * [MDN]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
 * [Contributors]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods$history
 * [CC-BY-SA]: https://creativecommons.org/licenses/by-sa/4.0/legalcode
 */

let HTTPMethod;

(function (HTTPMethod) {
  HTTPMethod["CONNECT"] = "CONNECT";
  HTTPMethod["DELETE"] = "DELETE";
  HTTPMethod["GET"] = "GET";
  HTTPMethod["HEAD"] = "HEAD";
  HTTPMethod["OPTIONS"] = "OPTIONS";
  HTTPMethod["PATCH"] = "PATCH";
  HTTPMethod["POST"] = "POST";
  HTTPMethod["PUT"] = "PUT";
  HTTPMethod["TRACE"] = "TRACE";
})(HTTPMethod || (HTTPMethod = {}));

var HTTPMethod$1 = HTTPMethod;

export default HTTPMethod$1;
export { HTTPMethod };
